module.exports = __webpack_public_path__ + "dd5f45416babd536c3f8adefd154f1ed.svg";